<section id="banner">
  <div id="banners-carousel" class="carousel slide prevent-carousel-remove" data-ride="carousel">
    <ol class="carousel-indicators" >
      <li *ngFor="let item of sliders; let idx = index" data-target="#banners-carousel" [attr.dataSlideTo]="idx" class="{{ idx == 0 ? 'active' : ''}}"></li>
    </ol>
    <div class="carousel-inner prevent-carousel-remove" role="listbox">
      <div *ngIf = 'sliders.length == 0' class="carousel-item prevent-carousel-remove active">
        <div class="banner width-100">
          <img src="assets/imgs/banner-b.png"  alt="Bannière de l'évènement mis en avant" class="width-100">
          <div class="top-left  margin-top--8-mini margin-top--8-mini-min-width-900  margin-top--8-mini-max-width-768 margin-top--8-mini-min-width-1200">
            <h2 class="home-page-title-color font-size-29-mini-max-width-768 font-size-29-mini-min-width-900 font-size-29-mini-min-width-1200">Découvrez des évènements <br> fait pour vous  </h2>
            <h4 class="pading-left-10 margint-top-7 font-size-18-mini-min-width-900 font-size-18-mini-max-width-768 font-size-18-mini-min-width-1200">  et participez à des moments uniques.</h4>
            <a class="create-event-button-min-width-900 create-event-button-max-width-768 create-event-button-min-width-768-900 create-event-button-min-width-1200" href="https://pro.akces.fr/">{{'home.create_an_event'| translate}}</a>
          </div>
        </div>
      </div>
      <div *ngFor="let item of sliders; let idx = index" class="carousel-item prevent-carousel-remove {{ idx == 0?'active':'' }}" >
        <div class="banner width-100">
          <img src="{{ item.image|assetimage }}" onError="this.src='assets/imgs/banner.png'" *ngIf="item.image" alt="Bannière de l'évènement mis en avant" class="width-100">
            <img src="assets/imgs/banner.png" *ngIf="!item.image" alt="Image de l'évènement" class="width-100">
          <div class="overlay width-100 flexible">
          <!--  [routerLink]="['/event/' , slugify(item.name), item.id ]"-->
            <a  href="/event/{{slugify(event.name)}}/{{event.id}}" target="_self"  class="btn btn-style {{ getTicketingType(item).class }}"  >{{ getTicketingType(item).label| translate }}</a>
          </div>
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" href="#banners-carousel" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">{{'home.previous'| translate}}</span>
    </a>
    <a class="carousel-control-next" href="#banners-carousel" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">{{'home.next'| translate}}</span>
    </a>
  </div>
</section>

<!-- A découvrir -->
<section id="discover-events" *ngIf = 'discoverArray.length > 0' >
  <div class="container carousel slide" data-ride="carousel" id="discover-events-carousel">
    <header class="section-header">
     <div>
       <i class="fa fa-bookmark"></i>
       <span class="title inline-block">{{'home.discover'| translate}}</span>
     </div>
     <ul class="actions align-right flexible compact-children-margin" id="slider-cmds">
       <li class="prev">
         <a href="#discover-events-carousel" role="button" data-slide="prev" title="Précédent">
           <i class="fa fa-angle-left"></i>
           <span class="sr-only">{{'home.previous'| translate}}</span>
         </a>
       </li>
       <li class="next">
         <a  href="#discover-events-carousel" role="button" data-slide="next" title="Suivant">
           <i class="fa fa-angle-right"></i>
           <span class="sr-only">{{'home.next'| translate}}</span>
         </a>
       </li>
     </ul>
    </header>

    <div class="section-content">
      <div class="carousel-inner">
        <ul *ngFor="let item of discoverArray; let idx = index" [ngClass]="{'active' : idx == 0}" class="app-carousel-list list carousel-item compact-children-padding">
          <li *ngFor = 'let event of item' class="event width-50" style="display: inline-block;"  >
            <div>
             <!-- [routerLink]="['/event/' , slugify(event.name), event.id ]"-->
            <a href="/event/{{slugify(event.name)}}/{{event.id}}" target="_self" title="" class="inline width-100">
              <div class="evt-img-wrapper flexible text-center">
                <div *ngIf="event.thumbnail">
                  <img src="{{ event.thumbnail|assetimage }}" onError="this.src='assets/imgs/banner.png'"  alt="Image de l'évènement" class="height-100">
                </div>
                <div *ngIf="!event.thumbnail">
                  <img src="{{ event.image|assetimage }}" onError="this.src='assets/imgs/banner.png'" *ngIf="event.image"  alt="Image de l'évènement" class="height-100">
                  <img src="assets/imgs/banner.png" *ngIf="!event.image"  alt="Image de l'évènement" class="height-100">
                </div>
              </div>
              <div class="evt-details">
                <div class="flexible event-date-wrapper">
                  <h6 class="inline-block evt-date date-color font-size-18">{{ event.start_date|datefrench }} à {{event.start_hour| hourpipe }}</h6>
                  <!--<h6 class="inline-block evt-time">
                    <i class="inline-block fa fa-clock-o"></i>
                    {{ event.start_hour| hourpipe }}
                  </h6>-->
                  <!-- <h6 class="inline-block evt-time"><i class="inline-block"></i>{{ event.timezone }}</h6>-->
                </div>
                <h3  class="block evt-place h3-font-size">{{ event.name }}</h3>
                <h6 class="block evt-location">
                  <i class="fa fa-map-marker"></i>
                  <span>{{event.city+'&nbsp;'}}</span> <span><span class="square-dot"></span></span> <span class="margin-left-5">{{event.location_name }}</span>
                </h6>
              </div>
             <!-- [routerLink]="['/event/' , slugify(event.name), event.id ]"-->
              <div class="evt-actionbar flexible">
                <a  href="/event/{{slugify(event.name)}}/{{event.id}}" target="_self" title="{{ getTicketingType(event).title | translate  }}" class="btn btn-style {{ getTicketingType(event).class }}"  >{{ getTicketingType(event).label| translate }}</a>
              </div>
            </a>
            </div>
          </li>
        </ul>
      </div>
  </div>
  </div>
</section>

<!-- Évènements à venir -->
<section id="upcoming-events">
  <div class="container">
    <header class="section-header section-header--column">
      <div class="section-header__first">
        <i class="fa fa-calendar"></i>
        <h1 class="title inline-block coming_event_title">{{'home.comming_evet'| translate}}</h1>
      </div>
      <div class="section-header__last">
        <ul class="actions align-right flexible compact-children-margin">
          <li [ngClass]="{'active': selected == 'semaine'}"  id="activeWeekEvents"><a (click)="getWeeksevents()"  href="javascript:void(0);" title="Cette semaine" class="text-uppercase">{{'home.this_week'| translate}}</a></li>
          <li [ngClass]="{'active': selected == 'mois'}" id="activeMonthEvents"><a (click)="Monthevents()" href="javascript:void(0);" title="Ce mois" class="text-uppercase">{{'home.this_month'| translate}}</a></li>
        </ul>
      </div>
    </header>

    <div class="section-content">
      <div class="row flexible">
        <div class="flexible flex-wrap col-md-6 col-sm-6" *ngFor="let event of events">
          <div class="event">
           <!-- [routerLink]="['/event/' , slugify(event.name), event.id ]"-->
            <a href="/event/{{slugify(event.name)}}/{{event.id}}" target="_self"  class="inline-block width-100">
              <div class="evt-img-wrapper event-thumbox flexible text-center">
                <div *ngIf="event.thumbnail" class="event-thumbox ">
                  <img src="{{ event.thumbnail|assetimage }}" onError="this.src='assets/imgs/banner.png'" alt="Image de l'évènement" class="event-thumb">
                  <img *ngIf="applySolidarityFlag(event)" src="{{getRightSolidarytyFlagByLang()}}"    alt="Image de l'évènement" class=" float-image-sup float-image  float-img-dim-sup">
                  <img src="assets/imgs/banner.png" *ngIf="!event.image"  alt="Image de l'évènement" class="height-100">
                </div>
                <div *ngIf="!event.thumbnail">
                  <img src="{{ event.image|assetimage }}" onError="this.src='assets/imgs/banner.png'"  *ngIf="event.image" alt="Image de l'évènement" class="height-100">
                </div>
               <!-- <ng-template *ngIf="!event.thumbnail" #banner_content>
                 <img src="{{ event.image|assetimage }}" alt="Image de l'évènement" class="height-100">

                </ng-template>-->
              </div>

              <div class="evt-details">
                <div class="flexible event-date-wrapper">
                  <h6 class="inline-block evt-date date-color font-size-18">  {{event.start_date | datefrench}} à {{event.start_hour| hourpipe }}</h6>
                  <!--<h6 class="inline-block evt-time">
                    <i class="inline-block fa fa-clock-o"></i>
                    {{event.start_hour| hourpipe }}
                   &lt;!&ndash; {{ event.timezone }}&ndash;&gt;
                  </h6>-->

                </div>

                <h3 class="block evt-place heigh-55 h3-font-size">{{event.name}}</h3>
                <h6 class="block evt-location" *ngIf="!eventIsOnline(event) && !eventNotHaveLocation(event)">
                  <i class="fa fa-map-marker"></i>
                  <span>{{event.city+'&nbsp;'}}</span> <span><span class="square-dot"></span></span> <span class="margin-left-5">{{event.location_name }}</span>
                </h6>

                <h6 class="block evt-location" *ngIf="eventIsOnline(event) && !eventNotHaveLocation(event)">
                  <img src="../../../assets/imgs/icon-web.png" alt="icon-web" style="width: 30px;height: 30px">
                  <!--<i class="fa fa-map-marker"></i>-->
                  <span>{{'En ligne'+'&nbsp;'}}</span> <span><span class="square-dot"></span></span> <span class="margin-left-5">{{event.onlineType }}</span>
                </h6>
              </div>

              <!--[routerLink]="['/event/' , slugify(event.name), event.id ]"-->
              <div class="evt-actionbar flexible">
                <a href="/event/{{slugify(event.name)}}/{{event.id}}" target="_self" title="{{ getTicketingType(event).title | translate  }}" class="btn btn-style {{ getTicketingType(event).class }}"  >{{ getTicketingType(event).label| translate }}</a>
               <!--  <h6 class="evt-infos text-red" *ngIf="event.has_ticketing==true && event.pricings[0]">
                  <i class="fa fa-ticket"></i>
                  <span>{{event.pricings[0].Totalplace}}</span>
                  Billets disponibles
                </h6>-->
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-6 message-orga titlium-web">
      <h2 class="color-blue font_home-size-17-768">{{'home.you_organize_event'| translate}}</h2>
      <h5 class=" font_home-size-12-768"><span class="color-blue margin-bottom-15">{{'home.create_your_event_and_touch'| translate}}</span> <span class="blue2">{{'home.its_simple_fast'| translate}}</span> </h5>
      <a   href="https://pro.akces.fr/"  title="Créer un évènement" class="btn inline-block  createBtn" style=""> {{'home.Create_an_event'| translate}}</a>
    </div>
  </div>
</section>
